import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { inOrderColumns, pjSortableColumns } from '../constants';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';

const FilterComponentPJ = ({ onPropertyChange, legalFormsData, filters, specialFilters }) => {
  const [t] = useTranslation();

  return (
    <>
      <Grid item xs={12} sm={6} lg={4} key={1}>
        <TextField
          id={`browserContainerPJ_filters_cui`}
          fullWidth
          label={t('OfferEdit.Client.PJ.PersonalIdentifier')}
          value={specialFilters.uniqueId}
          onChange={value => onPropertyChange(value, 'uniqueId')}
          inputProps={{
            maxLength: 255
          }}
          debounceBy={500}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4} key={2}>
        <TextField
          id={`browserContainerPJ_filters_companyName`}
          fullWidth
          label={t('OfferEdit.Client.PJ.CompanyName')}
          value={specialFilters.name}
          onChange={value => onPropertyChange(value, 'name')}
          inputProps={{
            maxLength: 255
          }}
          debounceBy={500}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4} key={3}>
        <Autocomplete
          id={`browserContainerPJ_filters_legalForm`}
          fullWidth
          value={filters.legalFormId}
          label={t('OfferEdit.Client.PJ.LegalForm')}
          simpleValue
          valueKey={'legalFormId'}
          labelKey={'legalFormName'}
          options={legalFormsData}
          onChange={value => onPropertyChange(value, 'legalFormId')}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <Autocomplete
          id={'listFilter_orderByPJ'}
          label={t('Tooltips.OrderBy')}
          valueKey={'id'}
          labelKey={'name'}
          value={filters.orderByColumn}
          onChange={value => onPropertyChange(value, 'orderByColumn')}
          fullWidth
          simpleValue
          options={pjSortableColumns.map(item => {
            return {
              id: item.columnName,
              name: t(item.displayNameKey)
            };
          })}
        />
      </Grid>

      <Grid item xs={12} sm={6} lg={4}>
        <Autocomplete
          id={'listFilter_orderByPJ'}
          label={t('Tooltips.InOrder')}
          valueKey={'id'}
          labelKey={'name'}
          value={filters.orderByDescending}
          onChange={value => onPropertyChange(value, 'orderByDescending')}
          fullWidth
          isClearable
          simpleValue
          options={inOrderColumns.map(item => {
            return {
              id: item.columnName,
              name: t(item.displayNameKey)
            };
          })}
        />
      </Grid>
    </>
  );
};
FilterComponentPJ.propTypes = {
  onPropertyChange: PropTypes.func.isRequired,
  legalFormsData: PropTypes.array.isRequired,
  onColumnChange: PropTypes.func,
  filters: PropTypes.object.isRequired,
  specialFilters: PropTypes.object
};

export default FilterComponentPJ;
